<template>
  <div>
    <Toolbar :handle-delete="del">
      <template slot="left">
        <v-toolbar-title v-if="item">{{
          `${$options.servicePrefix} ${item['@id']}`
        }}</v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-animationcategorie-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>Field</th>
              <th>Value</th>

              <th>Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('slug') }}</strong></td>
              <td>
                                    {{ item['slug'] }}
              </td>
            
              <td><strong>{{ $t('nom') }}</strong></td>
              <td>
                                    {{ item['nom'] }}
              </td>
            </tr>
            
            <tr>
              <td><strong>{{ $t('parametreAffichage') }}</strong></td>
              <td>
                                    {{ item['parametreAffichage'] }}
              </td>
            
              <td><strong>{{ $t('animations') }}</strong></td>
              <td>
                                    {{ item['animations'].name }}
              </td>
            </tr>
            
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'AnimationCategorie';

export default {
  name: 'AnimationCategorieShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin],
  computed: {
    ...mapFields('animationcategorie', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('animationcategorie', ['find'])
  },
  methods: {
    ...mapActions('animationcategorie', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
